export default "./images/survio-24BI7-assets-matrix.png";